export default __webpack_public_path__ + "static/media/lunarMod1.1.e15aaf58.jpeg";